import { Container, createStyles, Grid, makeStyles, Paper, Theme } from "@material-ui/core";
import { observer } from "mobx-react";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        paper: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            position: 'relative' // the loading spinner refers to this element
        },
        content: {
            marginBottom: theme.spacing(2)
        },
        alert: {
            marginTop: theme.spacing(2)
        }
    })
);

export const NoticePage = observer(() => {

    /********* React hooks *********/

    const classes = useStyles();

    /********* Render *********/

    return (
        <Container className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Container>
                            <div className={classes.content}>
                                <Alert severity="warning" className={classes.alert}>
                                    <AlertTitle>Your organization administrator access has been revoked.</AlertTitle>
                                    If you believe this was in error, please contact another administrator at the organization to correct the issue.
                                </Alert>
                            </div>
                        </Container>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
});
